<template>
  <div>
    <div id="loading-wrapper" ref="loadingWrapper">
			<div class="spinner">
				<div class="line1"></div>
				<div class="line2"></div>
				<div class="line3"></div>
				<div class="line4"></div>
				<div class="line5"></div>
				<div class="line6"></div>
			</div>
		</div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <card>
          <div slot="header">
            <h4 class="title">Reporte de ganancias</h4>
          </div>
          <div>
            <form>
              <div class="row">
                <div class="col-md-4 form-group has-label">
                  <label>Tiraje</label>
                  <el-select class="select-primary"
                              size="large"
                              placeholder="Tiraje"
                              v-model="report.run">
                    <el-option v-for="option in this.report.runsList"
                                :value="option.value"
                                :label="option.label"
                                :key="option.label">
                    </el-option>
                  </el-select>
                </div>
                <div class="col-md-4 form-group has-label">
                  <label>Autor</label>
                  <el-select class="select-primary"
                              size="large"
                              placeholder="Autor"
                              v-model="report.author">
                    <el-option v-for="option in this.report.authorsList"
                                :value="option.value"
                                :label="option.label"
                                :key="option.label">
                    </el-option>
                  </el-select>
                </div>
              </div>

              <!-- <div class="row">
                <div class="col-md-4">
                  <fg-input type="date" label="Desde" placeholder="Desde" v-model="report.start">
                  </fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input type="date" label="Hasta" placeholder="Hasta" v-model="report.end">
                  </fg-input>
                </div>
                <div class="col-md-4">
                  &nbsp;
                </div>
              </div> -->

              <div>
                <button
                  type="submit"
                  class="btn btn-primary btn-fill btn-wd"
                  @click.prevent="generateReport"
                >
                <i class="fa fa-file"></i> &nbsp;Generar reporte
                </button>
                &nbsp; &nbsp;
                <button
                  type="submit"
                  class="btn btn-primary btn-fill btn-wd"
                  @click.prevent="generateReportCSV"
                >
                <i class="fa fa-download"></i> &nbsp;Generar Excel
                </button>
                <button
                type="submit"
                class="btn btn-default btn-fill btn-wd pull-right"
                @click.prevent="clearFilters"
              >
                Limpiar filtros
              </button>
              </div>
              <div class="clearfix"></div>
            </form>
          </div>
        </card>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <card>
          <el-table
            class="table-striped"
            :data="tableData">
            <el-table-column type="index" width="80"></el-table-column>
            <el-table-column prop="runname" label="Tiraje"></el-table-column>
            <el-table-column prop="totalcost" label="Costo total" align="right"></el-table-column>
            <el-table-column prop="pricebooks" label="Venta total" align="right"></el-table-column>
            <el-table-column prop="profit" label="Ganancia" align="right"></el-table-column>
            <el-table-column prop="runbooks" label="Producidos" align="right"></el-table-column>
            <el-table-column prop="soldbooks" label="Vendidos" align="right"></el-table-column>
            <el-table-column prop="leftbooks" label="Restantes" align="right"></el-table-column>
            <el-table-column prop="editprofit" label="Editorial" align="right"></el-table-column>
            <el-table-column prop="autprofit" label="Autor" align="right"></el-table-column>
          </el-table>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Input, Tag, Select, Option } from 'element-ui'
import { Table, TableColumn } from 'element-ui'
import axios from "axios";

export default {
  components: {
    [Input.name]: Input,
    [Tag.name]: Tag,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      tableData: [],
      report: {
        locationsList: [],
        runsList: [],
        authorsList: [],
        location: '',
        run: '',
        author: '',
        start: '',
        end: ''
      }
    };
  },
  mounted () {
    this.fetchDataFromAPI();
  },
  methods: {
    generateReport () {
      let wrapper = this.$refs.loadingWrapper;
      wrapper.style.display = 'block';

      axios.get(
          this.$systemVariables.apiUrl +
          'reports/profit?rand=' + Math.random().toString() +
          '&location=' + this.report.location +
          '&author=' + this.report.author +
          '&run=' + this.report.run +
          '&start=' + this.report.start +
          '&end=' + this.report.end,
          {
            'headers': { 'Authorization': JSON.parse(localStorage.getItem('jwt')).value }
          })
        .then((response) => {
          this.tableData = response.data.message;
        });
      wrapper.style.display = 'none';
    },
    generateReportCSV () {
      let wrapper = this.$refs.loadingWrapper;
      wrapper.style.display = 'block';

      axios.get(
          this.$systemVariables.apiUrl +
          'reports/profit?rand=' + Math.random().toString() +
          '&location=' + this.report.location +
          '&author=' + this.report.author +
          '&run=' + this.report.run +
          '&start=' + this.report.start +
          '&end=' + this.report.end,
          {
            'headers': { 'Authorization': JSON.parse(localStorage.getItem('jwt')).value }
          })
        .then((response) => {
          this.tableData = response.data.message;
          let csv = 'Tiraje,Costo total,Venta total,Ganancia,Producidos,Vendidos,Restantes,Editorial,Autor\n';
          this.tableData.forEach((row) => {
                  csv += "\"" +row.runname + "\"" + "," +
                    "\"" + row.totalcost + "\"" + "," +
                    "\"" + row.pricebooks + "\"" + "," +
                    "\"" + row.profit + "\"" + "," +
                    "\"" + row.runbooks + "\"" + "," +
                    "\"" + row.soldbooks + "\"" + "," +
                    "\"" + row.leftbooks + "\"" + "," +
                    "\"" + row.editprofit + "\"" + "," +
                    "\"" + row.autprofit + "\"";
                  csv += "\n";
          });

          const anchor = document.createElement('a');
          anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
          anchor.target = '_blank';
          anchor.download = 'reporte-ganancias.csv';
          anchor.click();
        });

      wrapper.style.display = 'none';
    },
    async fetchDataFromAPI() {
      let wrapper = this.$refs.loadingWrapper;
      wrapper.style.display = 'block';

      axios.get(this.$systemVariables.apiUrl + 'locations?perPage=500&forSelect=1&rand=' + Math.random().toString(), {
        'headers': { 'Authorization': JSON.parse(localStorage.getItem('jwt')).value }
      })
      .then((response) => {
        this.report.locationsList = response.data.message;
      });
      axios.get(this.$systemVariables.apiUrl + 'runs?perPage=500&forSelect=1&addAll=1&rand=' + Math.random().toString(), {
        'headers': { 'Authorization': JSON.parse(localStorage.getItem('jwt')).value }
      })
      .then((response) => {
        this.report.runsList = response.data.message;
      });
      axios.get(this.$systemVariables.apiUrl + 'authors?perPage=500&forSelect=1&rand=' + Math.random().toString(), {
        'headers': { 'Authorization': JSON.parse(localStorage.getItem('jwt')).value }
      })
      .then((response) => {
        this.report.authorsList = response.data.message;
      });

      wrapper.style.display = 'none';
    },
    clearFilters() {
      this.report.location = '';
      this.report.run = '';
      this.report.author = '';
      this.report.start = '';
      this.report.end = '';
      return;
    }
  },
};
</script>
<style>
  .el-input__inner {
    cursor: pointer !important;
  }
  .el-table .warning-row {
    background: oldlace;
  }
</style>
